<template>
<div>
  <v-toolbar dense style="background:royalblue;color:white;font-weight:bold">
     Downline List
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-data-table
      :headers="headers"
      :items="statementlist"
      :loading="loading"
      hide-actions
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
       <template slot="items" slot-scope="props">
         <td >{{ props.item.UserId}}</td>         
        <td >{{ props.item.UserName}}</td>         
        <td >{{ props.item.MobileNo}}</td>         
        <td >{{ props.item.Balance}}</td>         
        <td >{{ props.item.Type}}</td>         
      </template>      
    </v-data-table>
</div>
</template>

<script>
export default {
   data(){
      return{
         loading:false,
         headers: [
               { text: 'User ID', value: 'UserId'},       
               { text: 'User Name', value: 'UserName' },            
               { text: 'Mobile No', value: 'MobileNo' },            
               { text: 'Balance', value: 'Balance' },            
               { text: 'Username', value: 'Type' },            
         ],
         statementlist:[]
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
      fetchstatement(){ 
         let vm = this;
         if(vm.user.length==0) return 
         vm.loading = true
         let doc ={
             MobileNo:vm.user.phone,
             PinNo:vm.user.pin,
             UserId:"",
             UserMobileNo:""
         }
         vm.$store.dispatch("axios",{
            url:"GetchiledTree",
            data:doc
         }).then(function (res) {   
            console.log(res.data);   
            vm.statementlist =[]
            if(res.data.Data!=null){
                vm.statementlist = res.data.Data;
            }
            vm.loading = false         
         }).catch(function (error) {
               console.log(error);                           
               vm.$store.dispatch("notify",{vm:vm,message:error,type:"warn"})     
         })
  },

     },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }

}
</script>


<style scoped>
.search{
   width:150px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>

